<template>
  <WebsiteCmsShell
    class="website-doctor-page"
    :title="'Dokter Spesialis ' + clinic_name"
    subtitle="Tampilkan profil dokter agar pasien mudah menemukan tenaga medis yang tepat"
    action-label="Dokter Baru"
    list-eyebrow="Profil dokter"
    list-title="Dokter yang ditampilkan"
    list-description="Kelola profil, spesialisasi, urutan, dan status tampil dokter."
    @action="$router.push('/website/doctor/add')"
  >
    <template #list><Table purpose="master" /></template>
  </WebsiteCmsShell>
</template>

<script>
import WebsiteCmsShell from "@/component/websites/WebsiteCmsShell.vue";
import Form from "@/component/websites/DoctorForm.vue";
import FormEdit from "@/component/websites/DoctorFormEdit.vue";
import FormDetail from "@/component/websites/DoctorFormDetail.vue";
import Table from "@/component/websites/DoctorTable.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "website-doctor",
  data() {
    return {
      form: {
        name: "",
        specialty: "",
        description: "",
        image: [],
        order: null,
        status: "",
      },
      FormDetailActv: false,
      FormEditActv: false,
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    };
  },
  components: {
    WebsiteCmsShell,
    Form,
    FormEdit,
    FormDetail,
    Table,
  },
  methods: {
    resetFormOnNew() {
      // reset form on new (tambah data)
      var self = this;
      Object.keys(this.form).forEach(function (key, index) {
        if (key === "image") {
          self.form[key] = [];
        } else if(key === "_method"){
          self.form[key] = "post"
        }  else {
          self.form[key] = "";
        }
      });
    },

    scrollToElement(options) {
      let el = this.$el.getElementsByClassName("website-cms-editor-anchor")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    scrollToTop(options) {
      // window.scrollTo(0, 0);
      let el = this.$el;
      // el = el ?? this.$el.getElementsByClassName("table-setting")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    btnAddOnClick() {
      this.FormEditActv = false
      this.FormDetailActv = false
      this.scrollToElement({ behavior: 'smooth' })
    },


  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Website", route: "" },
      { title: "CMS", route: "" },
      { title: "Dokter Spesialis", route: "" },
    ]);

    // Add Website Doctor
    this.$root.$on("updateWebsiteDoctor", () => {
      // reset form on new (tambah data)
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });

    // Cancel Add Website Doctor
    this.$root.$on("cancelAddWebsiteDoctor", () => {
      // reset form on new (tambah data)
      this.scrollToTop({ behavior: "smooth" });
      this.resetFormOnNew();
    });

    //  Edit Website Doctor
    this.$root.$on("getWebsiteDoctorById", (data) => {
      this.FormDetailActv = false
      this.FormEditActv = true
      this.scrollToElement({ behavior: 'smooth' })

      if (data.status == 0) {
        data.status = false
      } else if (data.status == 1) {
        data.status = true
      }

      this.form = data
      this.form['_method'] = 'put'
    });

    // Cancel Edit
    this.$root.$on("cancelWebsiteDoctorUpdate", () => {
      this.FormEditActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });

    // Detail Web Doctor
    this.$root.$on("getWebsiteDoctorByIdDetail", (data) => {
      this.FormDetailActv = true
      this.FormEditActv = false
      this.scrollToElement({ behavior: 'smooth' })

      if (data.status == 0) {
        data.status = false
      } else if (data.status == 1) {
        data.status = true
      }
      this.form = data
    });

    // Close Detail
    this.$root.$on("closeWebsiteDoctorDetail", () => {
      this.FormDetailActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });
  },
};
</script>
